import { render } from "./LinkInput.vue?vue&type=template&id=b660d496&scoped=true"
import script from "./LinkInput.vue?vue&type=script&lang=js"
export * from "./LinkInput.vue?vue&type=script&lang=js"

import "./LinkInput.vue?vue&type=style&index=0&id=b660d496&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b660d496"]])

export default __exports__